<div style="display: flex; flex-direction: column; height: 90vh;">
    <app-breadcrumb></app-breadcrumb>
  <div class="d-flex justify-content-between" style="height: 8vh;">
    <h1>Balcão Virtual</h1>
    <div style="
      width: 24vh;
      display: flex;
      flex-direction: row;
      place-content: space-between;
      align-self: center;
      height: 6.5vh;">
    </div>
  </div>

  <hr style="margin: 0;" />

  <div style="flex: 1;">
    <iframe
      [src]="safeUrl"
      width="100%"
      height="100%"
      style="border: none; display: block;"
    ></iframe>
  </div>

  
</div>
